// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { FORMID, TestRunParams } from "./TestRunConstants";
import { ROUTE_DEFINITIONS, getPath } from "../../routes/routes";
import React, { useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";

import Divider from "../ui/Divider";
import TimedStep from "./TimedStep";
import { setStepReady } from "./TestRunStepReadyEmitter";
import { useTestRunConfig } from "./useTestRunConfig";

// Renders the step with a ten minute timer while the solution reacts
// with the test strip.
const WaitStep = () => {
  const { getNextDefaultStep } = useTestRunConfig();
  const startTime = Date.now();
  const history = useHistory();
  const { step, testRunUID } = useParams<TestRunParams>();

  const stepReadyCallback = useCallback(
    (stepReady: boolean) => {
      setStepReady(step, stepReady);
    },
    [step]
  );

  const onSubmit = useCallback(
    event => {
      event.preventDefault();
      stepReadyCallback(false);
      const nextStep = getNextDefaultStep({
        currentStepName: step!,
      });
      const path = getPath(ROUTE_DEFINITIONS.PERFORMTEST, {
        params: {
          ":testRunUID": testRunUID,
          ":step": nextStep!,
        },
      });
      history.push(path);
    },
    [stepReadyCallback, getNextDefaultStep, step, testRunUID, history]
  );

  // TODO: USC-935 use redux state for this
  /* useEffect(() => {
    const getStartTime = async () => {
      const firebaseApp = await getFirebaseApp();
      const userUID = auth!.uid;

      const listSymptomsStep = await firebaseApp.getTestRunStep({
        step: "waitStripReaction",
        testRunUID,
        userUID,
      });
      listSymptomsStep?.firstVisitedTime &&
        setStartTime(listSymptomsStep.firstVisitedTime);
    };

    getStartTime();
  }, [auth, testRunUID]); */

  // TODO: Generic Error handler.
  if (!step) {
    return <div>Oops, something went wrong</div>;
  }

  // We show the timer.
  return (
    <>
      <Divider />
      <TimedStep
        description="The test cassette will take 15 minutes to react with the test solution."
        duration={startTime + 900000 - Date.now()}
        testRunUID={testRunUID}
        setStepReady={stepReadyCallback}
      />
      <form style={{ display: "none" }} id={FORMID} onSubmit={onSubmit} />
    </>
  );
};

export default WaitStep;
